export const PRICE_HISTORY_TIMEZONE = 'Europe/Brussels'

export const MONTH_KEY_FORMAT = 'YYYY-MM'

export const MONTHS_IN_YEAR = 12
